import { EnvironmentType } from '@shared/utils/enums';
import { environment } from 'src/environments/environment';

export const matchEnvironment = (environments: EnvironmentType[] | null | undefined): boolean => {
  if (!environment || !environments?.length) {
    return true;
  }

  return environments.some((environmentType) => environmentType === environment.environment);
};
